"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    sampleMessage: {
        id: 'sample.message',
        defaultMessage: 'My sample message',
        description: 'This is a sample message for testing',
    },
});
exports.default = messages;
